import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { ConversionStrip } from "@/components/ConversionStrip";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { ShowcaseBanner } from "@/components/ShowcaseBanner";
import { Regions } from "@/components/Regions";
import { About } from "@/components/About";
import { Testimonials } from "@/components/Testimonials";
import { Contact } from "@/components/Contact";
import { InstagramSection } from "@/components/InstagramSection";
import { Footer } from "@/components/Footer";
import { FloatingWhatsapp } from "@/components/FloatingWhatsapp";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    window.__lenis = lenis;
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#050505] min-h-screen">
      <Header />
      <main>
        <Hero />
        <ConversionStrip />
        <Marquee />
        <Services />
        <ShowcaseBanner />
        <Regions />
        <About />
        <Testimonials />
        <Contact />
        <InstagramSection />
      </main>
      <Footer />
      <FloatingWhatsapp />
    </div>
  );
}

export default App;
